module.exports = __webpack_public_path__ + "img/system1.0c7cf1c3.png";